import { createFileRoute } from '@tanstack/react-router'

import { TenantLimitsPage } from '@/pages/tenants/detail/TenantLimitsPage'

export const Route = createFileRoute('/_authenticated/tenants/$id/limits')({
  component: TenantLimitsPage,
})
